import React from "react";
import { deleteSvg } from "@assets";

import { deleteNode } from "../utils/deleteNode";

import "./ButtonDelete.scss";

export const ButtonDelete = ({ setNodes, setEdges, nodeId, handleDelete }) => {
  const handleClickAdd = () => {
    deleteNode({ setNodes, setEdges, nodeId });
    handleDelete && handleDelete();
  };

  return (
    <span className="context-add-button">
      <button onClick={handleClickAdd} className={"delite-node-button"}>
        {deleteSvg()}
      </button>
    </span>
  );
};
